module.exports = __webpack_public_path__ + "static/media/lp-edu-2.3340cd98.svg";